/* eslint-env browser */
import * as React from 'react'

const PropTypes = require('prop-types')
const classNames = require('classnames')

const OneUser = require('./UserItem')
const LargeUserItem = require('./LargeUserItem')

class UsersGrid extends React.Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  render() {
    const { simpleGrid, customItemClassName, users } = this.props

    return (
      <div className={classNames('columns is-mobile is-multiline is-centered is-variable is-1')}>
        {users.map(elt => (
          <div
            className={classNames('column', customItemClassName || 'is-6-mobile is-4-tablet is-3-desktop')}
            key={elt.id}
          >
            {simpleGrid && <OneUser user={elt} />}
            {!simpleGrid && <LargeUserItem user={elt} />}
          </div>
        ))}
      </div>
    )
  }
}

UsersGrid.propTypes = {
  users: PropTypes.array.isRequired,
  simpleGrid: PropTypes.bool,
  customItemClassName: PropTypes.string,
}

UsersGrid.defaultProps = {
  simpleGrid: false,
  customItemClassName: null,
}

module.exports = UsersGrid
